import React from 'react';

import {HorizontalTrend} from "../../trend/horizontal-trend";
import classNames from "classnames";
import styles from "./odds-tooltip.content.module.scss";

export const OddsTooltipContentTrend = ({option}) => {
  return option.shouldRenderTrend ? <div className={classNames(styles.trend)}>
    <HorizontalTrend trend={option.trend}/>
  </div> : null
};
